module.exports = __webpack_public_path__ + "static/money-box-f0f82660c476f240b899c142ccbf017a.svg";